import Vue from 'vue'
import Vuex from 'vuex'

// modules
import user from "./modules/user.js"
import album from "./modules/album.js"
import newsletter from "./modules/newsletter.js"
import content from "./modules/content.js"
import page from "./modules/page.js"

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    user,
    album,
    newsletter,
    content,
    page
  }
})
